<div class="ebay-revenue-dialog" mat-dialog-content>
    <h2>Ebay Revenue - {{transaction.description}}</h2>
    
    <div class="container">

        <div class="left">
            <ngx-dropzone (change)="submitProof($event)">
                <ngx-dropzone-label>Upload Evidence</ngx-dropzone-label>
            </ngx-dropzone>
        </div>

        <div class="right">
            <div class="payout" *ngFor="let payout of transaction.ebayPayouts">
                <ng-container *ngIf="payout.type == 'Order'">
                    <div>Order:</div>
                    <div matTooltip="Actual total price of order">{{payout.amount | human}}</div>
                    <div>{{payout.fees | human}}</div>
                    <div>{{payout.order}}</div>
                    <div>{{payout.invoice}}</div>
                </ng-container>
                <ng-container *ngIf="payout.type == 'Refund'">
                    <div>Refund:</div>
                    <div matTooltip="Full Refund">{{payout.refund | human}}</div>
                    <div>{{payout.fees | human}}</div>
                    <div>{{payout.order}}</div>
                    <div>{{payout.invoice}}</div>
                </ng-container>
                <ng-container *ngIf="payout.type == 'Postage label'">
                    <div>Postage:</div>
                    <div matTooltip="Full Refund">{{payout.fees | human}}</div>
                </ng-container>
                <ng-container *ngIf="payout.type == 'Hold'">
                    <div matTooltip="Funds on Hold">FOH:</div>
                    <div matTooltip="Full Refund">{{payout.fees | human}}</div>
                </ng-container>
                <ng-container *ngIf="payout.type == 'Charge'">
                    <div>Charge:</div>
                    <div>{{payout.refund | human}}</div>
                </ng-container>
                <ng-container *ngIf="payout.type == 'Ebay Expense'">
                    <div>Expense:</div>
                    <div>{{payout.fees | human}}</div>
                </ng-container>
            </div>

            <div class="totals">
                Payout: <span matTooltip="Current Balance in ebay transaction account">{{transaction.amount | human}}</span><br>
                <br>
            </div>

            <div class="transfers">
                <div class="transfer" *ngFor="let transfer of transfers">
                    <mat-form-field class="description" appearance="outline" subscriptSizing="dynamic">
                        <input matInput maxlength="24" [ngModel]="truncateTransferNote(transfer.transactionDescription)" (ngModelChange)="updateTransferDescription(transfer, $event)">
                    </mat-form-field>
                    <ap-money class="amount" [inDollars]="true" [outline]="true" [(amount)]="transfer.amount"></ap-money>
                </div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button (click)="save()" mat-raised-button>Save</button>
    <button (click)="close(null)" mat-raised-button>Cancel</button>
    <!-- <button (click)="fuck()" mat-raised-button>Fuck</button> -->
    <button (click)="check()" mat-raised-button>Check</button>
    <button [disabled]="!allowCommit" (click)="commit()" mat-raised-button>Commit</button>
</div>
